import {appModelService} from './app-model.services';
import {appServices} from './app.services';
import {persistentServices} from './persistent.services';
import {utilsServices} from './utils.services';
import {watchdogServices} from './watchdog.services';

let serviceModule = angular
  .module('app.services', [])
  .service('appModel', appModelService)
  .service('appServices', appServices)
  .service('persistent', persistentServices)
  .service('utils', utilsServices)
  .service('watchdog', watchdogServices)

  .name;

  export default serviceModule;



// WEBPACK FOOTER //
// ./client/app/services/services.js